module.exports = __webpack_public_path__ + "static/media/beta.b44961b2.png";